import React, { useState } from "react";
import { Box, Button, DialogActions, DialogContent, Typography } from "@mui/material";
import { MimshakData } from "../../../interfaces/DTO/mimshakData";
import { PathFundSelection } from "../../../hooks/feeLab/useNewProductHandlers";
import { formatCurrency } from "../../../utils/namesFormater";
import PolicyPickList from "./PolicyPickList";
import PathChooser from "./PathChooser";
import { PathChangeAction, isBasketNewFund, newActionId, policyLabel } from "./quickActions";

interface Props {
  policies: MimshakData[];
  onComplete: (action: PathChangeAction) => void;
  onCancel: () => void;
  /** under the policy list (e.g. "הצג הכל" when the policies are filtered) */
  policiesFooter?: React.ReactNode;
}

/**
 * שינוי מסלול: איזו קופה → למסלול אחד חדש או פיצול למספר מסלולים → המסלולים החדשים אצל היצרן של הקופה.
 * בקופה חדשה מניוד – בחירת המסלול שלה. רק בונה את הפעולה ומחזיר אותה ב-onComplete.
 */
const PathChangeForm: React.FC<Props> = ({ policies, onComplete, onCancel, policiesFooter }) => {
  const [policy, setPolicy] = useState<MimshakData | null>(null);
  const [selections, setSelections] = useState<PathFundSelection[]>([]);

  const pickPolicy = (p: MimshakData) => {
    setPolicy(p);
    setSelections([]);
  };

  const handleComplete = () => {
    if (!policy || selections.length === 0) return;
    onComplete({ kind: "path_change", id: newActionId(), policy, selections });
  };

  if (!policy) {
    return (
      <>
        <DialogContent sx={{ p: 0 }}>
          <Typography variant="subtitle2" sx={{ px: 3, pt: 1 }}>
            באיזו קופה?
          </Typography>
          <PolicyPickList policies={policies.filter((p) => (p.funds_sum || 0) > 0)} onPick={pickPolicy} footer={policiesFooter} />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={onCancel} variant="outlined" size="large">
            חזור
          </Button>
        </DialogActions>
      </>
    );
  }

  return (
    <>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box>
            <Typography variant="body2" color="text.secondary">
              קופה
            </Typography>
            <Typography variant="body1" fontWeight={600}>
              {policyLabel(policy)} · {isBasketNewFund(policy) ? "קופה חדשה" : policy.policy_number} · {formatCurrency(policy.funds_sum || 0)}
            </Typography>
            <Button size="small" onClick={() => setPolicy(null)} sx={{ px: 0 }}>
              החלף קופה
            </Button>
          </Box>

          <PathChooser policy={policy} selections={selections} onSelectionsChange={setSelections} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined" size="large">
          חזור
        </Button>
        <Button onClick={handleComplete} disabled={selections.length === 0} variant="contained" size="large">
          הוסף
        </Button>
      </DialogActions>
    </>
  );
};

export default PathChangeForm;
